module.exports = __webpack_public_path__ + "static/media/-sabanci-logo.62004717.jpg";